"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickChatCommands = exports.quickChatReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {};
_a = (0, toolkit_1.createSlice)({
    name: "quickChat",
    initialState,
    reducers: {
        setPlayerChat: (state, { payload: { sendingPlayerId, chatValue }, }) => (Object.assign(Object.assign({}, state), { [sendingPlayerId]: { value: chatValue, receivedAt: Date.now() } })),
        clearPlayerChat: (state, { payload: { sendingPlayerId }, }) => {
            const next = Object.assign({}, state);
            delete next[sendingPlayerId];
            return next;
        },
    },
}), exports.quickChatReducer = _a.reducer, exports.QuickChatCommands = _a.actions;
